import { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Dropdown, DropdownButton } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';

import SignOut from '../modals/SignOut';
import ChangePassword from '../modals/ChangePassword';
import ThemeChange from '../common/ThemeChange';
import { RefreshIcon, logo, menuIcon } from '../../assets/images/images';

const Header = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const pathname = location.pathname;
    const [activeTab, setActiveTab] = useState('/adminDashboard');
    const [showSignOut, setShowSignOut] = useState(false);
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [syncing, setSyncing] = useState(false);
    const tabsRef = useRef<HTMLUListElement | null>(null);
    const [tabSliderStyle, setTabSliderStyle] = useState({
        left: 0,
        width: 0,
        opacity: 0,
    });

    const handleTabClick = (tab: any) => {
        navigate(tab);
    };

    const handleSyncing = () => {
        setSyncing(true);
        setTimeout(() => {
            setSyncing(false);
        }, 5000);
    };

    useEffect(() => {
        setActiveTab(pathname);
    }, [pathname]);

    const updateTabSlider = useCallback(() => {
        const tabsEl = tabsRef.current;
        if (!tabsEl) return;
        const activeEl = tabsEl.querySelector('.Tabs__tab.Tab.active') as HTMLElement | null;
        if (!activeEl) {
            setTabSliderStyle({ left: 0, width: 0, opacity: 0 });
            return;
        }
        const tabsRect = tabsEl.getBoundingClientRect();
        const activeRect = activeEl.getBoundingClientRect();
        setTabSliderStyle({
            left: activeRect.left - tabsRect.left,
            width: activeRect.width,
            opacity: 1,
        });
    }, []);

    useEffect(() => {
        updateTabSlider();
    }, [activeTab, updateTabSlider]);

    useEffect(() => {
        const handleResize = () => updateTabSlider();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [updateTabSlider]);

    return (
        <>
            <div className="header-content">
                <div className="logo-section">
                    <a href='/' className="logo">
                        <img width='93px' height='55px' src={logo} alt="logo" />
                    </a>
                </div>
                <div className="header-nav">
                    <div className="Panel">
                        <nav>
                            <ul className="Tabs" ref={tabsRef}>
                                <li
                                    className={`Tabs__tab Tab ${activeTab === '/adminDashboard' ? 'active' : ''
                                        }`}
                                    onClick={() => handleTabClick('/adminDashboard')}
                                >
                                    <button type="button" className="admin-main-tab-btn">Admin Dashboard</button>
                                </li>
                                <li
                                    className={`Tabs__tab Tab ${activeTab === '/adminUsers' ? 'active' : ''
                                        }`}
                                    onClick={() => handleTabClick('/adminUsers')}
                                >
                                    <button type="button" className="admin-main-tab-btn">User Management</button>
                                </li>
                                <li
                                    className={`Tabs__tab Tab ${activeTab === '/adminPlans' ? 'active' : ''
                                        }`}
                                    onClick={() => handleTabClick('/adminPlans')}
                                >
                                    <button type="button" className="admin-main-tab-btn">Manage Plans</button>
                                </li>
                                <li
                                    className={`Tabs__tab Tab ${activeTab === '/adminAnalytics' ? 'active' : ''
                                        }`}
                                    onClick={() => handleTabClick('/adminAnalytics')}
                                >
                                    <button type="button" className="admin-main-tab-btn">Analytics</button>
                                </li>
                                <li
                                    className="Tabs__presentation-slider"
                                    role="presentation"
                                    style={{
                                        left: `${tabSliderStyle.left}px`,
                                        width: `${tabSliderStyle.width}px`,
                                        opacity: tabSliderStyle.opacity,
                                    }}
                                >
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="header-right">
                    <div className="header-theme-toggle-mobile">
                        <ThemeChange />
                    </div>
                    <div className="user-profile me-3">
                        <Button className='upgrade-header-btn sync-btn' onClick={handleSyncing}>
                            <img src={RefreshIcon} alt="sync" className="sync-icon" />
                            { syncing ? 'Syncing...' : 'Sync Data' }
                        </Button>
                    </div>
                    <div className="menu-dropdown">
                        <DropdownButton id="dropdown-item-button" title={<img src={menuIcon} alt="dot" />}>
                            <Dropdown.ItemText>profile settings</Dropdown.ItemText>
                            <Dropdown.Item as="button" onClick={() => setShowChangePassword(true)}>Change Password</Dropdown.Item>
                            <Dropdown.Item as="button" className="red-color" onClick={() => setShowSignOut(true)}>
                                Sign Out
                            </Dropdown.Item>
                        </DropdownButton>
                    </div>
                </div>
            </div>

            {showSignOut && (
                <SignOut
                    showSignOut={showSignOut}
                    setShowSignOut={setShowSignOut}
                />
            )}

            {showChangePassword && (
                <ChangePassword
                    showChangePassword={showChangePassword}
                    setShowChangePassword={setShowChangePassword}
                />
            )}
        </>
    );
};

export default Header;
